var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "Dialog",
    _vm._g(
      _vm._b({ attrs: { width: _vm.width } }, "Dialog", _vm.$attrs, false),
      _vm.$listeners
    ),
    [
      _c("div", { staticClass: "preview" }, [
        _c("div", {
          staticClass: "dialog-close close",
          on: {
            click: function ($event) {
              return _vm.$emit("close")
            },
          },
        }),
        _vm.src ? _c("img", { attrs: { src: _vm.src, alt: "" } }) : _vm._e(),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }